import { ReactNode } from 'react';
import { KeyboardStoreProvider } from '../hooks/stores/keyboardStore';
import { MouseStoreProvider } from '../hooks/stores/mouseStore';
import { UIStoreProvider } from '../hooks/stores/uiStore';
import { UserSessionStoreProvider } from '../hooks/stores/sessionStore';
import { LauncherStatesStoreProvider } from '../hooks/stores/launcherStatesStore';
import { LauncherWindowStoreProvider } from '../hooks/stores/launcherWindowStore';
import { LauncherElementsStoreProvider } from '../hooks/stores/launcherElementsStore';

export const StoreProviders = ({ children }: { children: ReactNode }) => {
  return (
    <KeyboardStoreProvider>
      <MouseStoreProvider>
        <UIStoreProvider>
          <UserSessionStoreProvider>
            <LauncherStatesStoreProvider>
              <LauncherWindowStoreProvider>
                <LauncherElementsStoreProvider>
                  {children}
                </LauncherElementsStoreProvider>
              </LauncherWindowStoreProvider>
            </LauncherStatesStoreProvider>
          </UserSessionStoreProvider>
        </UIStoreProvider>
      </MouseStoreProvider>
    </KeyboardStoreProvider>
  );
};
